import { Component, OnInit, OnDestroy } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Observable, Subscription } from 'rxjs';
import { catchError, map, switchMap, share } from 'rxjs/operators';
import { Learnspace, ProgramTabs } from '@shared/models';
import { CurrentContextService } from '@shared/services/currentContextService';
import { AuthenticationService } from '@shared/services/authentication.service';
import { AddParticipantDialogComponent } from '@shared/components/add-participant-dialog/add-participant-dialog.component';

const allTabs = [ProgramTabs.Overview, ProgramTabs.Reporting, ProgramTabs.Participants, ProgramTabs.Settings];

@Component({
  selector: 'program-home',
  templateUrl: './program-home.component.html',
  styleUrls: ['./program-home.component.scss'],
  animations: fuseAnimations
})
export class ProgramHomeComponent implements OnInit, OnDestroy {
  public learnspace: Learnspace;
  ls: Observable<Learnspace>;
  private subscription: Subscription;
  private activeTab = ProgramTabs.Overview;

  constructor(
    private _courseApiService: CoursesAPIService,
    private _CurrentContextService: CurrentContextService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _currentHubService: CurrentHubService,
    protected _dialog: MatDialog,
    private _authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.ls = this._route.paramMap.pipe(
      map((param) => {
        return param.get('lsId');
      }),
      switchMap((id) => {
        return this._courseApiService.getLearnspaceById(id)

      }),
      catchError((err) => {
        if (err.status === 404) {
          this._router.navigate(['/error'], { queryParams: { status: err.status } });
        }
        throw err;
      }),
      share()
    );

    this.subscription = this.ls.subscribe((ls) => {
      this.learnspace = ls;
    });

    this._route.queryParams.subscribe(async (params) => {
      this.activeTab = params.activeTab;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedIndex() {
    const index = allTabs.indexOf(this.activeTab);
    return index >= 0 ? index : 0;
  }

  onSelectedIndexChange(index: number): void {
    let newTab = ProgramTabs.Overview;
    if (index >= 0 && index < allTabs.length) {
      newTab = allTabs[index];
    }

    const params: Params = { activeTab: newTab };
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: params,
      queryParamsHandling: newTab === ProgramTabs.Reporting ? 'merge' : undefined,
    });
  }

  showLsParticipants(learnspace: Learnspace, event: any): void {
    event.stopPropagation();
    const user = this._authService.wondaUser.id;
    this._dialog.open(AddParticipantDialogComponent, {
      width: '500px',
      height: '60vh',
      data: { learnspace: learnspace, user_id: user }
    });
  }

  getParticipantsCount(learnspace: Learnspace): number {
    if (learnspace.participantCount !== undefined) {
      return parseInt(learnspace.participantCount);
    } else if (learnspace.Participants) {
      return learnspace.Participants.length;
    } else {
      return 0;
    }
  }

  navigateToProgram() {
    this._router.navigate([this._currentHubService.hub.urlTitle]);
  }

}
